export const isAdmin = (role) =>
  role == "ADMIN" || role == "SUPER_ADMIN" || "VENDOR";
